export enum Constants {
  SET_TOGGLE = 'SET_TOGGLE',
}

export type ToggleFieldActionTypes = any

export interface ToggleFieldState {
  toggle: boolean
}
